/**
 * Configuration for resume info. Provides information
 * on resume fields and mapping between API names and drupal naming structure.
 */
const jobiqoResumesConfig = require('./../src/jobiqo/config/resume');
const mergeDeepRight = require('ramda/src/mergeDeepRight');

const applicantsActive = true;
const resumeActive = true;

module.exports = mergeDeepRight(jobiqoResumesConfig, {
  // Insert config here. this will be deep merged with config from jobiqo. Arrays are not deep mergeable
  // so make sure to cover those with [...jobiqoCompanyConfig.public.SOME_KEY_THAT_IS_ARRAY, new_item ]
  public: {
    RESUME_FEATURE_ACTIVE: resumeActive,
    APPLICANT_FEATURE_ACTIVE: applicantsActive,
    RESUME_SEARCHES_FEATURE_ACTIVE: false,
    RESUME_CONTACT_FEATURE_ACTIVE: false,
    RESUME_IMPORT_FEATURE_ACTIVE: false,
    GEO_INFO: {
      radius: {
        unit: 'mi',
        unitMultiplier: 1.6,
        defaultValue: 25,
      },
      fixtures: [],
    }
  },
});
